import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '@tdwb/core';
import { PortfolioContactData } from './portfolio-contacts.component';

@Injectable()
export class PortfolioContactsRestService {

  constructor(private restService: RestService) {
  }

  getContactData(): Observable<PortfolioContactData> {
    return this.restService.getResource('portfolio.contact').get();
  }
}
